const ProductLineDefaults = {
  SafetyVideos: {
    SNO: 'https://player.vimeo.com/video/311550272?app_id=122963',
    PON: 'https://player.vimeo.com/video/281524959?app_id=122963',
    SLG: 'https://player.vimeo.com/video/241536951?app_id=122963',
    ATV: 'https://player.vimeo.com/video/241535929?app_id=122963',
    RZR: 'https://player.vimeo.com/video/241536529?app_id=122963',
    ACE: 'https://player.vimeo.com/video/241536529?app_id=122963',
    GEN: 'https://player.vimeo.com/video/241536529?app_id=122963',
    RGR: 'https://player.vimeo.com/video/241536529?app_id=122963',
    IND: null,
    OperatorCustom: null
  }
}

export default ProductLineDefaults
